import React from 'react';

interface AvatarProps {
  src?: string | null;
  alt?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fallback?: string;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
  src,
  alt = 'Avatar',
  size = 'md',
  fallback,
  className = '',
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-12 h-12 text-sm',
    lg: 'w-16 h-16 text-base',
    xl: 'w-24 h-24 text-lg',
  };
  
  const getFallbackInitials = () => {
    if (fallback) return fallback.charAt(0).toUpperCase();
    if (alt) return alt.charAt(0).toUpperCase();
    return 'U';
  };
  
  if (!src) {
    return (
      <div
        className={`
          ${sizeClasses[size]}
          rounded-full bg-gray-300 flex items-center justify-center font-medium text-gray-600
          ${className}
        `}
      >
        {getFallbackInitials()}
      </div>
    );
  }
  
  return (
    <img
      src={src}
      alt={alt}
      className={`
        ${sizeClasses[size]}
        rounded-full object-cover
        ${className}
      `}
    />
  );
};